import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "brandPicker", "brandText", "accentPicker", "accentText", "preview",
    "previewAccent", "fontInput"
  ]

  connect() {
    this.updatePreview()
  }

  brandFromPicker() {
    this.brandTextTarget.value = this.brandPickerTarget.value
    this.updatePreview()
  }

  brandFromText() {
    this.syncPicker(this.brandTextTarget, this.brandPickerTarget)
    this.updatePreview()
  }

  accentFromPicker() {
    this.accentTextTarget.value = this.accentPickerTarget.value
    this.updatePreview()
  }

  accentFromText() {
    this.syncPicker(this.accentTextTarget, this.accentPickerTarget)
    this.updatePreview()
  }

  previewFont() {
    const [file] = this.fontInputTarget.files
    if (!file) return

    const url = URL.createObjectURL(file)
    const font = new FontFace("CompanyPreviewFont", `url(${url})`)
    font.load().then((loadedFont) => {
      document.fonts.add(loadedFont)
      this.previewTarget.style.fontFamily = "CompanyPreviewFont, sans-serif"
      URL.revokeObjectURL(url)
    }).catch(() => URL.revokeObjectURL(url))
  }

  syncPicker(textTarget, pickerTarget) {
    if (/^#[0-9a-f]{6}$/i.test(textTarget.value)) pickerTarget.value = textTarget.value
  }

  updatePreview() {
    const brandColor = this.validColor(this.brandTextTarget.value, this.brandPickerTarget.value)
    const accentColor = this.validColor(this.accentTextTarget.value, this.accentPickerTarget.value)
    this.previewTarget.style.setProperty("--preview-brand", brandColor)
    this.previewTarget.style.setProperty("--preview-accent", accentColor)
  }

  validColor(value, fallback) {
    return /^#[0-9a-f]{6}$/i.test(value) ? value : fallback
  }
}
